// video widget here >>>
import fnSeoBlock from "../widgets/fnSeoBlock.js";

import fnCardWidget from "../widgets/fnCardWidget.js";
import fnManagedImage from "../widgets/fnManagedImage.js";

// signup here >>>

import customSocialIcons from "../../utils/customSocialIcons.js";
import customSocialFeedImages from "../../utils/customSocialFeedImages.js";

import * as utils from "../../utils/utils.js";

let themeName;
let themeURL;

// -------------------------
// HEADER
function createHeader(sparkThemeConfig) {
  themeName = sparkThemeConfig[3].navItemName;
  themeURL = sparkThemeConfig[3].navItemUrl;

  const themeHeading = "fNights-header";
  $(".header").addClass(themeHeading);

  const headerStructure = `
<div class="${themeHeading}InnerContent">
  <div class="top-bar-items"></div>

  <div class="bottom-bar-items">
    <div class="inner-content">

      <div class="left-content">
        <div class="search-content"></div>
      </div>
      <div class="right-content"></div>

    </div>
  </div>

</div>`;

  $(`.${themeHeading}`).append(headerStructure);

  const fNightLogo = $(`.main-theme-header .header-logo`);
  $(".fNights-headerInnerContent").find(".top-bar-items").append(fNightLogo);
  $(".fNights-headerInnerContent").find(".header-logo").attr({
    href: themeURL,
    "aria-label": themeName,
  });

  const fNightDirections = $(".fNight-header-content .fNightsDirections");
  const fNightSearch = $(`.fNight-header-content .searchBox`);
  const fNightCart = $(`.fNight-header-content .viewcart`);
  $(".fNights-headerInnerContent")
    .find(".left-content")
    .prepend(fNightDirections);
  $(".fNights-headerInnerContent").find(".search-content").append(fNightSearch);
  $(".fNights-headerInnerContent").find(".left-content").append(fNightCart);

  const fNightNavigation = $("#mainNavigation");
  const fNightToggle = $(".mobile-nav-toggle");
  const fNightTicket = $(".fNightsTicket");
  $(".fNights-headerInnerContent")
    .find(".right-content")
    .append(fNightNavigation);
  $(".fNights-headerInnerContent").find(".right-content").append(fNightTicket);
  $(".fNights-headerInnerContent").find(".right-content").append(fNightToggle);

  utils.customizeSearchBar(themeHeading, "searchBox", "Search Website");
  utils.removeOldHeader(themeHeading);
}

// -------------------------
// HOMEPAGE CONTENT
function createContent() {
  fnSeoBlock();

  fnCardWidget();
  fnManagedImage();

  customSocialIcons("fnSocialIcons", fnSocialIconsOpts, 5);
  customSocialFeedImages("fnSocialFeedImages", fnSocialFeedImagesOpts, 5);

  $(".content").empty();
  $(".content").addClass("fNights-content");
  $(".fNights-content").append(`

    <div class="tier-1-container">
      <div class="video-container">
      ${
        utils.checkWindowsSize(800)
          ? '<video id="videoBannerMobile" muted  loop playsinline type="video/mp4" media="(max-width:800px)"></video>'
          : '<video id="videoBanner" muted  loop playsinline type="video/mp4"></video>'
      }      
        <div id="placeholder-video" class="placeholder-video"></div>
      </div>
    </div>

    <div class="tier-2-container"></div>

    <div class="tier-3-container">
      <div class="inner-container"></div>
    </div>

    <div class="tier-signup-container">
      <div class="inner-container"></div>
    </div>

    <div class="tier-4-container">
      <div class="inner-container"></div>
    </div>

    <div class="tier-5-container">
      <div class="inner-container"></div>
    </div>

    `);

  const videoTag = videoSource;
  const videoTagMobile = videoSource;

  if (utils.checkWindowsSize(800)) {
    $(".fNights-content .video-container #videoBannerMobile").attr(
      "src",
      videoTagMobile
    );
    utils.validateVideoStatus("videoBannerMobile", "placeholder-video");
  } else {
    $(".fNights-content .video-container #videoBanner").attr("src", videoTag);
    utils.validateVideoStatus("videoBanner", "placeholder-video");
  }

  const fnSeoWidget = $("#fnSeoBlock");
  $(".fNights-content .tier-2-container").append(fnSeoWidget);

  const fnImage = $("#fnManagedImage");
  const fnCards = $("#fnCardWidget");
  $(".fNights-content .tier-3-container .inner-container").append(fnCards);
  $(".fNights-content .tier-3-container .inner-container").append(fnImage);

  const signupModule = $("#signup-section");
  $(".tier-signup-container .inner-container").append(signupModule);

  const fnSocial = $("#fnSocialSection");
  const socialIcons = $("#fnSocialIcons");
  const fnSocialWidget = $("#fnSocialFeedImages");
  $(".fNights-content .tier-4-container .inner-container").append(fnSocial);
  $(
    ".fNights-content .tier-4-container .inner-container .fnSocialSection .icons-wrap"
  ).append(socialIcons);
  $(".fNights-content .tier-4-container .inner-container").append(
    fnSocialWidget
  );

  const fnSponsors = $("#fn-sponsors");
  $(".fNights-content .tier-5-container .inner-container").append(fnSponsors);
  $("#fn-sponsors h2").prependTo(".tier-5-container .inner-container");

  utils.showContent("fNights-content");
  $(".afterContent").remove();
}

// -------------------------
// FOOTER
function createFooter() {
  const footerClass = "fNigtsFooter";

  $(".footer").addClass(`${footerClass}`);

  const footerStructure = `
    <div class="inner-container">
      <div class="info-container"></div>
      <div class="copy-wrapper"></div>
    </div>
    
    `;

  const fNightsFooterBase = $(`.${footerClass}`);
  $(fNightsFooterBase).append(footerStructure);

  const fNightInfo = $(".fNights-footer .info-data");
  const fNightLogo = $(`.main-theme-footer .footer-logo`);

  $(fNightsFooterBase).find(".inner-container").prepend(fNightLogo);
  $(fNightsFooterBase).find(".info-container").append(fNightInfo);
  $(fNightsFooterBase).find(".footer-logo").attr({
    href: themeURL,
    "aria-label": themeName,
  });

  const fNightCopy = $(`.main-theme-footer .copy-container`);

  $(fNightsFooterBase).find(".copy-wrapper").append(fNightCopy);

  $(".footer .fNights-footer").remove();
  $(".footer .main-theme-footer").remove();
  $(".footer .yesteryear-footer").remove();
  $(".footer .ag-zone-footer").remove();
  $(".footer .southFlorida-footer").remove();
}

export { createHeader, createContent, createFooter };
